import React, {useEffect, useRef, useState} from 'react';
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import fetchData from "../../../utils/fetchData";
import PageLoader from "../../../components/pageLoader";
import config from "../../../config/apiService.json";
import {validateSliderImageDimensionAndImageValidity, validateSliderImageSize} from "../utils/validateSliderImage";
import {deleteMethod, patchMethod, postMethod} from "../../../utils/httpServices";
import "../../../assets/css/adminPages/home/carousel.scss";

const CarouselSliderUpdate = () => {
    const [data, setData] = useState([]);
    const [activeSliderImageIndex, setActiveSliderImageIndex] = useState(0);
    const [activeSliderImageId, setActiveSliderImageId] = useState(0);
    const [showLoader, setShowLoader] = useState(true);

    const fileUploaderRef = useRef(null);
    const fileUpdaterRef = useRef(null);

    const {home, administrative} = config;
    const {carouselEndPoint} = home;

    const getData = async () => {
        const result = await fetchData(carouselEndPoint);
        setData(result);
        setActiveSliderImageId(result[0].id);
        setActiveSliderImageIndex(0);
        data && setShowLoader(false);
    }

    useEffect(() => {
        getData();
    }, []);

    const handleImageSelect = (selectedImageObjectIndex, selectedImageId) => {
        setActiveSliderImageIndex(selectedImageObjectIndex);
        setActiveSliderImageId(selectedImageId);
    }

    const handleUpdate = async (event) => {
        let file = event.target.files[0];
        let imageSizeValidationResult = validateSliderImageSize(file);
        let imageDimensionValidationResult = await validateSliderImageDimensionAndImageValidity(file);
        if (imageSizeValidationResult && imageDimensionValidationResult) {
            try {
                let formData = new FormData();
                formData.append('image', file);
                let response = await patchMethod(`${administrative.home.carouselUpdate}/${activeSliderImageId}`, formData);
                if (response) {
                    file = null;
                    await getData();
                    fileUpdaterRef.current.value = "";
                    toast.success("Image Updated!");
                }
            } catch (ex) {
                toast.error(ex.response.data);
            }
        }
    }

    const handleDelete = async () => {
        try {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#354e80',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await deleteMethod(`${administrative.home.carouselUpdate}/${activeSliderImageId}`);
                    if (response) {
                        await getData();
                        Swal.fire(
                            'Deleted!',
                            'Your file has been deleted.',
                            'success'
                        )
                    }
                }
            });
        } catch (ex) {
            toast.error(ex.response.data);
        }
    }

    const handleUpload = async (event) => {
        const file = event.target.files[0];
        let imageSizeValidationResult = validateSliderImageSize(file);
        let imageDimensionValidationResult = await validateSliderImageDimensionAndImageValidity(file);
        if (imageSizeValidationResult && imageDimensionValidationResult) {
            try {
                const formData = new FormData();
                formData.append('image', file);
                const response = await postMethod(`${administrative.home.carouselUpdate}`, formData);
                if (response) {
                    await getData();
                    toast.success("Image Uploaded!");
                    fileUploaderRef.current.value = "";
                }
            } catch (ex) {
                toast.error(ex.response.data);
            }
        }
    }
    return (
        <section className="carousel-slider-section">
            {showLoader && <PageLoader/>}
            {data &&
                <img
                    className="displayed-slider-image"
                    src={`data:image/jpg;base64,${data[activeSliderImageIndex]?.sliderBase64}`}
                    alt={data[activeSliderImageIndex]?.sliderTag}
                />
            }
            <div className='custom-container'>
                <div className='content-section'>
                    <div className='content-body'>
                        <div className="d-flex justify-content-end my-4">
                            <div className="image-upload">
                                <label htmlFor="imageInput" className="slider-image-input-icon">
                                    <i className="fa fa-pencil la-pencil-alt-icon"></i>
                                </label>
                                <input
                                    ref={fileUpdaterRef}
                                    id="imageInput"
                                    name="updatedFile"
                                    type="file"
                                    accept="image/png, image/gif, image/jpeg"
                                    onChange={(e) => handleUpdate(e)}
                                />
                            </div>
                            <div>
                                <label className="slider-image-delete-icon ml-2">
                                    <i className="fa fa-trash la-delete-icon" onClick={handleDelete}></i>
                                </label>
                            </div>
                            <div className="image-upload">
                                <label htmlFor="addSliderImage" className="slider-image-upload-icon ml-2">
                                    <i className="fa fa-cloud-upload la-upload-icon"></i>
                                </label>
                                <input
                                    ref={fileUploaderRef}
                                    id="addSliderImage"
                                    name="createdFile"
                                    type="file"
                                    accept="image/png, image/gif, image/jpeg"
                                    onChange={(e) => handleUpload(e)}
                                />
                            </div>
                        </div>
                        {
                            data &&
                            <div className='mb-5 admin-slider-image-card-container'>
                                {data.map((item, index) =>
                                    <img
                                        key={item.id}
                                        onClick={() => handleImageSelect(index, item.id)}
                                        className={`slider-image-card clickable ${index === activeSliderImageIndex ? 'active' : ''}`}
                                        src={`data:image/jpg;base64,${item?.sliderBase64}`}
                                        alt={item?.sliderTag}
                                    />
                                )}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CarouselSliderUpdate;
